export default "__VITE_ASSET__DWlzNv65__"